import axios from "axios";
import { apiPath } from "../configs";
import storage from "./storage";
import { toast } from "react-toastify";
storage.get("xAuthToken");

axios.interceptors.response.use(
  function onFulfilled(response) {
    return response;
  },
  function onRejected(error) {
    if (error.code === "ERR_NETWORK") {
      toast.error(error.message);
    }

    if (error.response && error.response.status === 401) {
      toast.error("Your session expired.");
      storage.clear();
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

const post = ({
  url = "",
  body = {},
  headers = {},
  queryParams = {},
  otherConfigs = {},
}) => {
  return axios.post(apiPath + url, body, {
    headers,
    params: queryParams,
    ...otherConfigs,
  });
};

const put = ({
  url = "",
  body = {},
  headers = {},
  queryParams = {},
  otherConfigs = {},
}) => {
  return axios.put(apiPath + url, body, {
    headers,
    params: queryParams,
    ...otherConfigs,
  });
};

const get = ({
  url = "",
  headers = {},
  queryParams = {},
  otherConfigs = {},
}) => {
  return axios.get(apiPath + url, {
    headers,
    params: queryParams,
    ...otherConfigs,
  });
};

const deleteRequest = ({
  url = "",
  headers = {},
  queryParams = {},
  otherConfigs = {},
}) => {
  return axios.delete(apiPath + url, {
    headers,
    params: queryParams,
    ...otherConfigs,
  });
};

export default {
  get,
  post,
  put,
  delete: deleteRequest,
};
